import React from "react"
import FormSection from "../FormElements/FormSection"
import FormSubmit from "../FormElements/FormSubmit"
import SuccessCheckmark from "../FormElements/SuccessCheckmark"
import PasswordInput from "../FormElements/PasswordInput"

export default class ResetPassword extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			error: this.props.error || null,
			success: false,
			loading: false,
			password: '',
			// password_confirmation: ''
		}

		this.onChange = this.onChange.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
	}

	render() {
		// console.log('ResetPassword', this.props)

		return (
			<div className="ResetPassword">
				<form className="FormElements" onSubmit={this.onSubmit}>
					{this.state.error && <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: I18n.t(this.state.error, {forgot_password_path: this.props.forgot_password_path})}}></div>}
					<h1>Change your password</h1>
					{
						this.state.success
						?
						this.renderSuccess()
						:
						this.renderForm()
					}
					{this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
				</form>
			</div>
		);
	}

	renderSuccess() {
		return (
			<div>
				<div className="FormInstructions">Your password has been changed successfully.</div>
				<SuccessCheckmark />
				<FormSection>	
					<div className="text-center">
						<a href={this.props.sign_in_path} className="btn btn-primary">Return to sign in</a>
					</div>
				</FormSection>
			</div>
		)
	}

	renderForm() {
		return (
			<div>
				<div className="FormInstructions">Your new password must be at least 8 characters long.</div>
				<FormSection>
					<PasswordInput placeholder="New password" name="password" value={this.state.password} onChange={this.onChange} />
					{/*<PasswordInput placeholder="Confirm new password" name="password_confirmation" value={this.state.password_confirmation} onChange={this.onChange} />*/}
				</FormSection>
				<FormSection>	
					<FormSubmit text="Reset Password" />
				</FormSection>			
			</div>
		);
	}

	/**
	* Change handlers
	*/

	onChange(e) {
		var { state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		var self = this;

		e.preventDefault()
		e.stopPropagation()

		this.setState({loading: true});

    $.ajax({
      type: 'POST',
      url: this.props.reset_password_path,
      data: {
      	password: btoa(this.state.password),
      	token: this.props.token,
      }
    }).done(function (data) {	
    	// console.log('reset_password_path done', data)
    	if (data && data.error) {
    		self.setState({loading: false, error: data.error, success: false})
    	} else {
    		self.setState({loading: false, error: null, success: true})
    	}
    });	
	}

}